import React from 'preact/compat';
import PropTypes from 'prop-types';

const List = ({ children, className, ...props }) => (
  <ul
    className={`list-group fu-list-group ${className}`}
    {...props}
  >
    {children}
  </ul>
);

List.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

List.defaultProps = {
  children: undefined,
  className: '',
};


const ListItem = ({
  children,
  className,
  ...props
}) => (
  <li
    className={`list-group-item fu-list-group-item ${className}`}
    {...props}
  >
    {children}
  </li>
);

ListItem.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
};

ListItem.defaultProps = {
  title: undefined,
  url: undefined,
  className: '',
};

const ListItemText = ({
  children,
  component: Component,
}) => (
  <Component>
    {children}
  </Component>
);

ListItemText.propTypes = {
  children: PropTypes.node,
  component: PropTypes.string,
};

ListItemText.defaultProps = {
  children: undefined,
  component: 'h6',
};

export { ListItem, ListItemText, List };
